function getAppID(pathName) {
  return pathName.split('/')?.[1];
}

export default getAppID;
